import cloneDeep from "lodash/cloneDeep";
import merge from "lodash/merge";
import unset from "lodash/unset";

import {
  RECEIVE_TEAMMATE_INVITATIONS,
  REMOVE_TEAMMATE_INVITATION,
} from "../../actions/shared/teammateInvitationActions";

const _defaultState = { items: {} };

const teammateInvitationReducer = (state = _defaultState, action) => {
  Object.freeze(state);

  switch (action.type) {
    case RECEIVE_TEAMMATE_INVITATIONS:
      return {
        ...state,
        items: {
          ...state.items,
          ...action.payload,
        },
      };
    case REMOVE_TEAMMATE_INVITATION:
      const toRemoveId = action.payload;
      const newState = cloneDeep(state);

      unset(newState, ["items", toRemoveId]);

      return newState;
    default:
      return state;
  }
};

export default teammateInvitationReducer;
